<template>
	<div>
		<el-dialog
		  :visible="visible"
		  :width="requiredDialogWidth"
		  @close='handleCancleYoutubePlay'
		  :fullscreen="true"
		  center>
		  <div style="height: 100vh;overflow: hidden;">
			  <div :class="$style.dialogClass">
			    	<youtube
						:video-id="videoId"
						player-width="100%"
						player-height='350'
						:player-vars="playerVars"
					></youtube>
					
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "playVideoDialog",
		props: {
			dialogVisible: {type: Boolean,default: ()=>(false)},
			videoId: String,
		},
		data(){
			return {
				requiredDialogWidth: '100%',
				visible: this.dialogVisible,
				playerVars: {
					autoplay: 1,
					rel:0,
					// controls:1,
					// modestbranding:1,
					// loop:0,
					autonext:0,
					showinfo:1,
					// thumbnails:0,
					cc_load_policy:0,
					// cc_lang_pref:0,
					iv_load_policy:3,
					enablejsapi:1,
					widgetid:2,
					
				},
			}
		},
		watch:{
			dialogVisible(){
				this.visible = this.dialogVisible;
			},
		},
		methods: {
			handleCancleYoutubePlay(){
				this.$emit('closePlayDialog')
			},
		},
	}
</script>
<style scoped >
/deep/	.el-dialog__body {
	padding:0;
	padding-top: 25px;
}
 /deep/	.el-dialog__body,
 /deep/ .el-dialog__header {
	background-color: #696969 !important;
}
/deep/	.el-dialog__headerbtn {
	top: 0.625rem;
}
/deep/	.el-dialog__headerbtn i {
	font-size: 3.125rem;
	color: white;
}
</style>
<style module>
.dialogClass{
	margin: 0 auto;
	width: 600px;
	height: 200px;
	background-color: black;
}
@media screen and (max-width:770px) {
	.dialogClass{
		margin: 0 auto;
		width: 350px;
		height: 200px;
		background-color: black;
	}
}
</style>